export default __webpack_public_path__ + "img/Inter-Regular_85c1287.woff2";